module.exports = __webpack_public_path__ + "media/application/images/icons/gift-fbaf0ce0229a96c105fc1127158963a2.svg";